<div class='warningBanner envBanner borderedSpanBanner'>
  Signed in as
  <span class='bg-light border border-dark px-3'>{{ masqueraderUsername }}</span>
  masquerading as
  <span class='bg-light border border-dark px-3'>{{ username }}</span>
</div>
